<template>
  <div class="view" id="spot" v-if="browsing === true">
    <div class="content" id="browse">
      <div class='inside-closer' v-on:click="close">✖</div>
      <div class='sub-heading padding-20'>Uställare 2017</div>
      <div class='heading'>Exhibition Stockholm</div>
      <div class='sub-heading padding-40 pad-sides' style="padding-bottom: 15px;">
        Utställda fotografer
      </div>
      <div>
        <div v-for="(winner, index) in winnerString" style="display: inline-block; margin-top: 5px;">
          {{winner}}<span v-if="index !== 19">,&nbsp</span>
        </div> 
      </div>
      <div class='sub-heading padding-40 pad-sides'>
        Alla foton
      </div>
      <div v-if="photosLoaded === true" style='padding: 15px 0px;'>
        <photoFeed v-bind:photos="winnerPhotos" show-user="true">
          <div slot="empty">Något gick fel, prova ladda om sidan!</div>
        </photoFeed>
      </div>
      <div v-else><loader colorClass='black'></loader></div>
      <div class='padding-80'></div>
      <div class='padding-80'></div>
    </div>
  </div>
</template>

<script>
import loader from '@/components/Loader'
import photoFeed from '@/components/photoFeed'
import db from '@/classes/Db'
export default {
  name: 'winnerFeed',
  data () {
    return {
      browsing: true,
      photosLoaded: false,
      winnerPhotos: []
    }
  },
  computed: {
    winnerString () {
      let winners = []
      winners = this.winnerPhotos.map((a, i) => {
        return a.username
      })
      let filtered = []
      for (var i = 0; i < winners.length; i++) {
        if (filtered.indexOf(winners[i]) === -1) {
          filtered.push(winners[i])
        }
      }
      return filtered.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
    }
  },
  methods: {
    close () {
      window.location.href = 'https://game.exhibitionstockholm.se'
    },
    browsePhotos () {
      this.browsing = true
    },
    getAllWinners () {
      db.database().ref('finalwinners').once('value', (snapshot) => {
        //  this.winnerPhotos = snapshot.val()
        snapshot.forEach((child) => {
          this.winnerPhotos.push(child.val())
        })
        this.photosLoaded = true
        console.log(this.winnerPhotos)
      })
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.getAllWinners()
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Winner Feed')
    }
  },
  beforeDestroy () {
  },
  components: { loader, photoFeed }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WinnerFeed.vue?7c324fd0